<template>
  <minimal-layout>
    <div class="onboarding-carousel">
      <v-carousel
        ref="vCarousel"
        v-model="activeItemIndex"
        :cycle="true"
        :show-arrows="false"
        height="100%"
        hide-delimiters
        interval="4000"
      >
        <v-carousel-item
          v-for="(item, index) in galleryOnboarding"
          :key="index"
          reverse-transition="fade"
          transition="fade"
        >
          <div class="slide_h" style="width:100%; height:auto;">
            <img :src="getCdn(item.image)"/>
          </div>
        </v-carousel-item>
      </v-carousel>
      <v-overlay v-model="openedDialog" opacity="0.02" persistent>
        <v-card class="text-center onboarding-dialog">
          <img
            v-if="!!project.project.logo"
            :src="getCdn(project.project.logo)"
            class="mb-3 mt-5 onboarding-logo"
          />
          <h1 class="mb-2">{{ project.project.name }}</h1>
          <div class="mb-4 project-description" v-html="project.project.introduction"></div>
          <v-divider/>
          <router-link
            :to="{name: 'order.overview.exterior'}"
            class="onboarding-nav-button v-btn mt-3 mb-3 px-4 py-3"
            tag="button"
          >
            {{ this.getLabel() }}
          </router-link>
        </v-card>
      </v-overlay>
    </div>
  </minimal-layout>
</template>

<script>
/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import store from '@/store';
import MinimalLayout from '@/layouts/Minimal.vue';
import { cdnUrl } from '@/utils/urls';
import { mapState } from 'vuex';

export default {
  /**
   * The name of the page.
   */
  name: 'HomeIndex',

  /**
   * The components that the page can use.
   */
  components: {
    MinimalLayout,
  },
  computed: {
    ...mapState(['project']),
    ...mapState(['exteriors']),
    galleryOnboarding() {
      let result = [];

      if (this.project.project && this.project.project.gallery.length > 0) {
        result = this.project.project.gallery
          .filter(item => item.image !== null && item.onboarding !== false
            // disclude vimeo videos item from onboarding slideshow
            && (!item.video || (item.video && !item.video.includes('vimeo.com'))));

        if (result.length === 0) {
          result = this.project.project.gallery;
        }
      }
      return result;
    },
  },
  data() {
    return {
      openedDialog: true,
      transitionType: 'fade-transition',
      activeItemIndex: 0,
    };
  },
  methods: {
    getCdn(source) {
      return cdnUrl(source);
    },
    getLabel() {
      return (store.state.project.project.cta_label &&
        store.state.project.project.cta_label !== 'MAIN CTA BUTTON')
        ? this.$t(store.state.project.project.cta_label)
        : this.$t('Find_your_home');
    },
  },
};
</script>
<style lang="scss">
.onboarding-carousel {
  margin: 0;
  box-shadow: none;
  max-height: 100% !important;
  height: 100% !important;
}

.onboarding-carousel {
  .v-window__container,
  .v-window-item,
  .v-responsive,
  .v-responsive__content {
    height: 100% !important;
  }

  .v-carousel__prev {
    left: 5px;
    @supports (left: 5px) {
      left: calc(env(safe-area-inset-left) + 5px);
    }
  }

  .v-carousel__next {
    right: 5px;
    @supports (right: 5px) {
      right: calc(env(safe-area-inset-left) + 5px);
    }
  }
}


.onboarding-carousel {
  .slide_h {
    position: absolute;
    /*height: 100%;*/
    /*width: 100%;*/
  }

  .fade {
    &-enter-active, &-leave-active, &-leave-to {
      transition: 2s ease-out;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }

    &-leave, &-enter, &-leave-to {
      opacity: 0;
    }
  }

  .item_container {
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;

    img,
    iframe {
      max-width: 100%;
      max-height: 100%;
    }

    img {
      display: block;
      margin: 0 auto;
    }

    @supports (-webkit-overflow-scrolling: touch) {
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::before {
        z-index: 200;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: calc(100% + 2px);
        background: transparent;
        pointer-events: none;
      }
    }
  }

  .image_caption {
    position: absolute;
    left: 0;
    bottom: 0;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;

    > div {
      padding: 12px 0;
    }

    @supports (padding-bottom: env(safe-area-inset-bottom)) {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  .image_wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .video_container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .video_wrap {
    width: 100%;
    position: relative;
    padding-bottom: 55.9%;
    @supports (-webkit-overflow-scrolling: touch) {
      height: 100%;
      padding-bottom: 0;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::before {
        z-index: 200;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: calc(100% + 2px);
        background: transparent;
        pointer-events: none;
      }
    }
  }

  .closeButton {
    position: absolute;
    left: 8px;
    top: 8px;
    color: #fff;
    font-size: 1em;
    z-index: 1;
    padding: 5px;
    cursor: pointer;
    display: none;

    &::before {
      content: "";
      position: absolute;
      left: 5px;
      top: 0;
      height: 0px;
      width: 0px;
      border-radius: 20px;
      box-shadow: 0 0 45px 40px rgba(0, 0, 0, 0.2);
    }

    span {
      position: relative;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
      vertical-align: middle;
      margin-left: 4px;
      top: 1px;
    }

    i {
      vertical-align: middle;
      position: relative;
    }

    @supports (top: env(safe-area-inset-top)) {
      top: calc(env(safe-area-inset-top) + 5px);
    }
  }
}

@media screen and (orientation: landscape) {
  .onboarding-carousel {
    .slide_h {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

@media screen and (orientation: portrait) {
  .onboarding-carousel {
    .slide_h {
      img {
        height: 100%;
      }
    }
  }
}

@media screen and (orientation: portrait) and (max-width: 960px) {
  .onboarding-carousel {
    .slide_h {
      img {
        height: 100%;
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .onboarding-carousel {
    .closeButton {
      display: block;
    }
  }
}

.onboarding-logo {
  max-height: 100px;
}

.onboarding-nav-button {
  background: var(--primary-color);
  color: #fff;
  font-size: 1em;
}

.onboarding-dialog {
  min-width: 600px;
  padding: 15px 25px;
  background-color: #fff !important;
  color: rgba(0, 0, 0, .87) !important;
}

.v-card h1 {
  font-size: 1.75em;
  font-weight: 400;
  text-transform: uppercase;
}

.v-card .project-description {
  font-size: 1.375em;
  font-weight: 400;
}

</style>
